import i18n from '../i18nService';
import { formsStorage } from './formsStorage';

const resolveForm = (formOrCode) => {
    if (formOrCode && typeof formOrCode === 'object') {
        const fromStorage = formsStorage.formsList.find(
            (it) => it.id === formOrCode.id || it.productForm === formOrCode.productForm,
        );
        return fromStorage ?? formOrCode;
    }
    if (typeof formOrCode === 'string') {
        return formsStorage.formsList.find((it) => it.productForm === formOrCode);
    }
    return null;
};

const getNameFromForm = (form, localeCode) => {
    if (form?.names?.length) {
        const found = form.names.find((it) => it.locale === localeCode);
        if (found?.name) {
            return found.name;
        }
    }
    return '';
};

export const formNamesService = {
    getLocalization(localeCode, formOrCode, withCodeReplace = false) {
        const form = resolveForm(formOrCode);
        const code = form?.productForm ?? (typeof formOrCode === 'string' ? formOrCode : '');
        const apiName = form ? getNameFromForm(form, localeCode) : '';
        if (apiName) {
            return apiName;
        }
        return withCodeReplace ? code : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.addFormItem.formName');
    },
};
